<template>
  <v-card>
    <v-card-title>
      Resize To
      <v-spacer />
      <v-autocomplete
        v-model="addResizeCoreProductId"
        dense
        :items="productsToShow"
        item-text="nameWithOrientation"
        item-value="id"
        label="Add Core Product"
        outlined
        clearable
        hide-details
        @change="addResizeCoreProduct"
      />
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-data-table
        disable-pagination
        hide-default-footer
        hide-default-header
        :headers="[
          { text: 'Name', value: 'name' },
          { text: '', value: 'actions' }
        ]"
        :items="product.resizeCoreProductIds"
      >
        <template #[`item.name`]="{ item }">
          {{ product_name_with_orientation(item) }}
        </template>
        <template #[`item.actions`]="{ item }">
          <v-icon
            color="primary"
            @click="removeResizeCoreProductId(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProductResize',
  data() {
    return {
      addResizeCoreProductId: null
    };
  },
  computed: {
    productsToShow() {
      const excludeIds = (this.product.resizeCoreProductIds || []).concat([this.product.id]);
      return this.products.filter(
        (x) => !excludeIds.includes(x.id) && x.active && x.allowTemplateCreation
      );
    },
    ...mapGetters({
      product_name_with_orientation: 'lookup/product_name_with_orientation',
      products: 'lookup/standard_products',
      product: 'products/edit_product'
    })
  },
  methods: {
    addResizeCoreProduct() {
      if (this.addResizeCoreProductId) {
        if (!this.product.resizeCoreProductIds) {
          this.product.resizeCoreProductIds = [];
        }
        this.product.resizeCoreProductIds.push(this.addResizeCoreProductId);
        this.$nextTick(() => {
          this.addResizeCoreProductId = null;
        });
      }
    },
    removeResizeCoreProductId(id) {
      const index = this.product.resizeCoreProductIds.findIndex((x) => x === id);
      if (index >= 0) {
        this.product.resizeCoreProductIds.splice(index, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__append-outer {
  margin: 0 !important;
  margin-left: 10px !important;
  height: 40px;
}
</style>
